import * as React from 'react';
import Button from '@mui/material/Button';
import { PlayArrow } from '@mui/icons-material';
import { useTheme } from '@mui/material';
import FeatureNotReadyDialog from 'components/FeatureNotReady';

const VideoTutorial = () => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  function handleClose() {
    setOpen(false);
  }
  return (
    <React.Fragment>
      <Button
        href="#"
        variant="outlined"
        startIcon={<PlayArrow />}
        sx={{
          backgroundColor: theme.palette.primary.main,
          ':hover': {
            backgroundColor: theme.palette.primary.light,
          },
          color: '#ffffff',
        }}
        onClick={handleClickOpen}
      >
        Video Tutorial
      </Button>
      <FeatureNotReadyDialog isOpen={open} handleClose={handleClose} />
    </React.Fragment>
  );
};

export default VideoTutorial;
